var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4668 18.9336C15.0986 18.9336 18.9336 15.0986 18.9336 10.4668C18.9336 5.84326 15.0903 2 10.4585 2C5.83496 2 2 5.84326 2 10.4668C2 15.0986 5.84326 18.9336 10.4668 18.9336ZM10.4668 17.5225C6.54883 17.5225 3.41943 14.3848 3.41943 10.4668C3.41943 6.55713 6.54053 3.41113 10.4585 3.41113C14.3765 3.41113 17.5142 6.55713 17.5225 10.4668C17.5308 14.3848 14.3848 17.5225 10.4668 17.5225ZM10.4668 10.002C11.6704 10.0103 12.6333 8.98096 12.6333 7.62793C12.6333 6.36621 11.6704 5.31201 10.4668 5.31201C9.26318 5.31201 8.30029 6.36621 8.30029 7.62793C8.30029 8.98096 9.26318 9.99365 10.4668 10.002ZM6.60693 14.7085H14.3267C14.6587 14.7085 14.8247 14.4844 14.8247 14.1855C14.8247 13.2559 13.4302 10.8569 10.4668 10.8569C7.50342 10.8569 6.10889 13.2559 6.10889 14.1855C6.10889 14.4844 6.2749 14.7085 6.60693 14.7085Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fabf9cef53f4462386a9173941531640.svg";
export { ForwardRef as ReactComponent };